import type { HomeState } from '@/types';
import { produce } from 'immer';

const initialState = {
	count: 0,
};

export const createHomeStore = (
	set: (
		state: Partial<HomeState> | ((state: HomeState) => Partial<HomeState>),
	) => void,
) => ({
	...initialState,
	resetState: () => set(initialState),
	setIsHydrated: (isHydrated: boolean) => set({ isHydrated }),
	setCount: (count: number) =>
		set(
			produce((state: HomeState) => {
				state.count = count;
			}),
		),
});
